import { Answer, Question } from "./models/Questions";

export default [
    new Question('Где планируется ремонт?', [
        new Answer('Новостройка'),
        new Answer('Вторичное жилье'),
    ], false, false),
    new Question('Выберите количество комнат', [
        new Answer('Студия'),
        new Answer('1'),
        new Answer('2'),
        new Answer('3'),
        new Answer('4'),
        new Answer('5'),
    ], false, false),
    new Question('Площадь квартиры', [
        new Answer('1', 50),
    ], false, true),
    new Question('Какой ремонт вам нужен?', [
        new Answer('Дизайнерский ремонт'),
        new Answer('Под ключ(с нуля до полной готовности)'),
        new Answer('Чистовой ремонт'),
        new Answer('Капитальный обычный ремонт'),
        new Answer('Черновой ремонт'),
        new Answer('Не знаю'),
    ], false, false),
    new Question('Какие материалы вам понадобятся?', [
        new Answer('Черновые материалы'),
        new Answer('Чистовые материалы'),
        new Answer('Не знаю')
    ], false, false)
]
